/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react';
const IGNORE_DEFAULTS = ['updated_at', 'created_at', 'deleted_at'];
const DEFAULT_CHANGELOG_TABLE_CONFIG = {
    metadata: {},
};
const ChangelogContext = React.createContext({
    changelogTableConfig: DEFAULT_CHANGELOG_TABLE_CONFIG,
});
function ChangelogContextProvider(props) {
    var _a;
    const { changelogTableConfig, children, } = props;
    /**
     * `ignore` and `dictionary` are used by "CustomCell" component - do these need
     * to be state? They may be fine to pass directly...
     */
    const [ignore] = useState(changelogTableConfig.ignore || IGNORE_DEFAULTS);
    const [dictionary] = useState((_a = props.dictionary) !== null && _a !== void 0 ? _a : {});
    const context = useMemo(() => {
        return {
            ignore,
            dictionary,
            changelogTableConfig,
        };
    }, [ignore, dictionary, changelogTableConfig]);
    return (React.createElement(ChangelogContext.Provider, { value: context }, children));
}
export { ChangelogContextProvider, ChangelogContext };
//# sourceMappingURL=ChangelogContext.js.map